import { CompanyMyJoinRequestsContent } from "../../features/companyWorkspace";

function CompanyMyJoinRequestsScreen() {
  return <CompanyMyJoinRequestsContent />;
}

export default CompanyMyJoinRequestsScreen;
